import { useRef } from 'react';

function MultiDocCard({
  title,
  subtitle,
  hint,
  accept,
  addLabel,
  addLabelMore,
  docs,
  uploading,
  onPick,
  onRemove,
}) {
  const fileInputRef = useRef(null);

  return (
    <div className="DocCard">
      <div className="DocCard-header">
        <div className="DocCard-info">
          <span className="DocCard-title">{title}</span>
          <span className="DocCard-sub">{subtitle}</span>
        </div>
        <span className="DocCard-badge">Optionnel</span>
      </div>

      {docs.map((doc, index) => (
        <div className="UploadZone is-filled" key={`${doc.file_name}-${index}`}>
          <span className="UploadZone-text">{doc.file_name}</span>
          <button className="UploadZone-remove" onClick={() => onRemove(index)}>×</button>
        </div>
      ))}

      {uploading ? (
        <div className="UploadZone">
          <span className="UploadZone-text">Import en cours…</span>
        </div>
      ) : (
        <div
          className="UploadZone is-dashed"
          onClick={() => fileInputRef.current?.click()}
        >
          <span className="UploadZone-text">{docs.length > 0 ? addLabelMore : addLabel}</span>
          <span className="UploadZone-hint">{hint}</span>
          <input
            ref={fileInputRef}
            type="file"
            accept={accept}
            multiple
            hidden
            onChange={(e) => {
              onPick(e.target.files);
              e.target.value = '';
            }}
          />
        </div>
      )}
    </div>
  );
}

export default MultiDocCard;
